module.exports = ".note-title {\n  text-transform: none;\n  margin-top: 5px; }\n\n.application-list .ecg-title {\n  margin-bottom: 5px; }\n"